<template>
  <div class="upload-content-tile">
    <div class="panel">
      <div class="panel-header">
        <h2>Import / Upload</h2>
      </div>
      <div class="panel-body">
    <!-- Party Name + Import VCN inline -->
    <div class="form-row two-inline">
      <div class="form-column">
        <label for="selectedShortName" class="form-label">Party Name</label>
        <select id="selectedShortName" v-model="formData.selectedShortName" class="custom-select">
          <option value="0">Select Party</option>
          <option v-for="party in party" :key="party.autoid" :value="party.autoid">
            {{ party.short_name }}
          </option>
        </select>
      </div>
      <div class="form-column import-vcn-column">
        <label for="importAdvanceVcn" class="form-label">Import VCN</label>
        <div>
          <v-select id="importAdvanceVcn" :options="importAdvanceOptions" label="displayLabel" :clearable="false"
                    v-model="formData.importAdvanceVcn" @input="onImportVcnSelect" placeholder="Select Import VCN" class="custom-vselect" selectOnTab="True"  />
        </div>
      </div>
    </div>

    <!-- Location, Vessel and Voyage inline -->
    <div class="form-row three-inline">
      <div class="form-column">
        <label for="location" class="form-label">Location</label>
        <select id="location" v-model="formData.location" class="custom-select">
          <option value="0">Select Location</option>
          <option v-for="location in locations" :key="location.locationid" :value="location.locationid">
            {{ location.Name }}
          </option>
        </select>
      </div>

      <div class="form-column">
        <label for="vesselName" class="form-label">Vessel Name</label>
        <select id="vesselName" v-model="formData.vesselName" class="custom-select">
          <option value="0">Select Vessel</option>
          <option v-for="vessel in vessel" :key="vessel.Vesselid" :value="vessel.Vesselid">
            {{ vessel.Name }}
          </option>
        </select>
      </div>

      <div class="form-column">
        <label for="voyageName" class="form-label">Voyage Name</label>
        <select id="voyageName" v-model="formData.voyageName" class="custom-select">
          <option value="0">Select Voyage</option>
          <option v-for="voyage in voyage" :key="voyage.Voyageid" :value="voyage.Voyageid">
            {{ voyage.Name }}
          </option>
        </select>
      </div>
    </div>
    <!-- Upload Type + File input inline -->
    <div class="form-row two-inline">
      <div class="form-column">
        <label for="uploadtype" class="form-label">Upload Type</label>
        <div>
          <input type="radio" id="advance" value="1" :aria-selected="true" v-model="formData.uploadtype">
          <label for="advance">Advance Upload</label>
          <input type="radio" id="igm" value="2" v-model="formData.uploadtype">
          <label for="igm">IGM Upload</label>
        </div>
      </div>

      <div class="form-column">
        <label for="file" class="form-label">Select File</label>
        <input type="file" id="file" @change="handleFileUpload" class="custom-file-input">
      </div>
    </div>

    <div class="form-actions" align="center">
      <button class="btn btn-upload" @click="uploadFile" :disabled="isSubmitting">Upload File</button>
      <button type="button" class="btn btn-save excel-button" @click="savequery" :disabled="isSubmitting">Save</button>
      <button class="btn btn-download" @click="DownloadFile" :disabled="isSubmitting">Download List</button>
    </div>
    <div class="table-container">
      <table class="transaction-table table-design">
        <thead>
          <tr>
            <th>
              <span>Sl. No</span>
            </th>
            <th>
              <span>Container</span>
            </th>
            <th>
              <span>Size</span>
            </th>
            <th>
              <span>Type</span>
            </th>
            <th>
              <span>Tare</span>
            </th>
            <th>
              <span>Gross</span>
            </th>
            <th>
              <span>Movement</span>
            </th>
            <th>
              <span>CFS</span>
            </th>
            <th>
              <span>Status</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="ld in fetchedList" :key="ld[0]" class="successful-task">
            <td>{{ ld[0] }}</td>
            <th>
              <span>{{ ld[1] }}</span>
            </th>
            <th>
              <span>{{ ld[2] }}</span>
            </th>
            <th>
              <span>{{ ld[3] }}</span>
            </th>
            <th>
              <span>{{ ld[4] }}</span>
            </th>
            <th>
              <span>{{ ld[5] }}</span>
            </th>
            <th>
              <span>{{ ld[6] }}</span>
            </th>
            <th>
              <span>{{ ld[7] }}</span>
            </th>
            <th>
              <span>{{ ld[8] }}</span>
            </th>
          </tr>
        </tbody>
      </table>
    </div>


      </div> <!-- .panel-body -->
    </div> <!-- .panel -->
  </div>
</template>

<script>
import axios from 'axios';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { useToast } from 'vue-toastification';
import * as cs from '../assets/js/commonscript.js'
import { saveAs } from 'file-saver';

export default {
  data() {
    return {
      party: JSON.parse(localStorage.getItem('party')),
      vessel: JSON.parse(localStorage.getItem('vessel')) || [],
      voyage: JSON.parse(localStorage.getItem('voyage')) || [],
      locations: [],
      importAdvanceOptions: [],
      uploadlist: [],
      sqlqry: null,
      isSubmitting: false,
      formData: {
        selectedShortName: 0,
        applicantName: 0,
        accountName: 0,
        location: 0,
        vesselName: 0,
        voyageName: 0,
        importAdvanceVcn: null,
        uploadtype: '',
        file: null,
      },
    }
  },
  created() {
    this.fetchMasterLocations();
    this.fetchImportVCNs();
  },
  components: {
    'v-select': vSelect,
  },
  computed: {
    fetchedList() {
      //console.log(this.successfulTasks);
      //console.log(this.uploadlist);
      return this.uploadlist;
    },
  },
  watch: {
        'formData.importAdvanceVcn'(value) {
            this.onImportVcnSelect(value)
        }
    },
  methods: {
    async fetchMasterLocations() {
      const token = localStorage.getItem('access_token');
      if (!token) {
        return;
      }
      try {
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        };
        const response = await axios.get('/master_location_list/', config);
        this.locations = response.data[2];
      } catch (error) {
        console.error('Error fetching Master Locations:', error);
      }
    },
    async fetchImportVCNs() {
      const token = localStorage.getItem('access_token');
      const config = token ? { headers: { accept: 'application/json', Authorization: `Bearer ${token}` } } : {};
      try {
        const response = await axios.get('/get_active_import_vcn', config);
        const data = Array.isArray(response.data) && response.data.length >= 3 ? response.data[2] : response.data;
        // Ensure there's always a default "Select VCN" option with value 0
        const items = Array.isArray(data) ? data.slice() : [];
        // Prepend default option if not already present
        if (!items.some(i => i && (i.vcnID === 0 || i.vcnID === '0'))) {
          items.unshift({ vcnID: 0, vcnName: 'Select VCN' });
        }
        // Add a combined displayLabel for each option: "VCN | Vessel | Voyage"
        const withLabel = items.map(it => {
          const vcn = it.vcnName || it.VCN || it.vcn || '';
          const vessel = it.VesselName || it.vesselName || it.Vessel || '';
          const voyage = it.import_voyageName || it.VoyageName || it.voyageName || it.import_voyage || '';
          const parts = [vcn, vessel, voyage].filter(p => p && p.toString().trim() !== '');
          return Object.assign({}, it, { displayLabel: parts.join(' | ') });
        });
        this.importAdvanceOptions = withLabel;
        // Set default selected option object so the select displays its label (e.g. 'Select VCN')
        this.formData.importAdvanceVcn = withLabel[0] || null;
      } catch (error) {
        console.error('Error fetching import VCNs:', error);
        this.importAdvanceOptions = [{ vcnID: 0, vcnName: 'Select VCN', displayLabel: 'Select VCN' }];
        this.formData.importAdvanceVcn = this.importAdvanceOptions[0];
      }
    },
    onImportVcnSelect(selected) {
      if (!selected) return;
      if (selected.vcnID === 0 || selected.vcnID === '0') {
        this.formData.vesselName = 0;
        this.formData.voyageName = 0;
        this.formData.location = 0;
        return;
      }
      const vesselId = selected.Vesselid || selected.VesselID || selected.vesselid || selected.vesselID || selected.vesselId || selected.vessel || selected.vesselID || selected.vesselid;
      const voyageId = selected.import_voyage || selected.import_voyageid || selected.import_voyageID || selected.import_voyageId || selected.Voyageid || selected.VoyageID || selected.voyageid || selected.voyageID;
      const locationId = selected.MlocID || selected.mlocID || selected.mlocid || selected.MlocId || selected.locationid || selected.locationID || selected.location;

      if (typeof vesselId !== 'undefined' && vesselId !== null) this.formData.vesselName = vesselId;
      if (typeof voyageId !== 'undefined' && voyageId !== null) this.formData.voyageName = voyageId;
      if (typeof locationId !== 'undefined' && locationId !== null) this.formData.location = locationId;
    },
    handleFileUpload(event) {
      this.formData.file = event.target.files[0];
    },
    async uploadFile() {
      if (this.isSubmitting) return;

      this.isSubmitting = true;
      try {
        this.uploadlist = [];
        this.sqlqry = null;
        this.updateApplicantAccountIds(this.formData.selectedShortName);
        const token = localStorage.getItem('access_token');
        const config = {
          headers: {
            'accept': 'application/json',
            Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data'
          }
        }
        const uploadData = new FormData();
        uploadData.append('applicantName', this.formData.applicantName);
        uploadData.append('accountName', this.formData.accountName);
        uploadData.append('location', this.formData.location);
        uploadData.append('vesselName', this.formData.vesselName);
        uploadData.append('voyageName', this.formData.voyageName);
        uploadData.append('uploadtype', this.formData.uploadtype);
        uploadData.append('file', this.formData.file);
        const response = await axios.post('/upload_import?applicantid=' + this.formData.applicantName + '&accountid=' + this.formData.accountName + '&locationid=' + this.formData.location + '&vessselid=' + this.formData.vesselName + '&voyageid=' + this.formData.voyageName + '&uploadtype=' + this.formData.uploadtype, uploadData, config);
        //console.log('File uploaded successfully:', response.data);
        if (response.data[0] == "0") {
          useToast().error(response.data[1]);
        } else {
          useToast().success('File uploaded successfully');
          this.uploadlist = response.data[2]
          this.sqlqry = response.data[3]
        }
      } catch (error) {
        console.error('Error uploading file:', error);
        useToast().error('An error occurred while uploading file');
      } finally {
        this.isSubmitting = false;
      }
    },
    async savequery() {
      if (this.isSubmitting) return;

      if (this.sqlqry === null) {
        useToast().error('Please select a file to upload');
        return;
      }

      this.isSubmitting = true;
      try {
        const token = localStorage.getItem('access_token');
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`
          },
        };
        const qrydata = {
          qry: this.sqlqry,
          uploadtype: this.formData.uploadtype
        }
        const data = new FormData();
        const transdt = JSON.stringify(qrydata)
        data.append('transaction', transdt)

        const response = await axios.post('/import_entry_execute', data, config);
        //console.log(response.data)
        if (response.data[0] === 0) {
          useToast().error(response.data[1]);
        } else {
          useToast().success(response.data[1]);
          this.uploadlist = []
          this.sqlqry = null
          //this.resetNewContainer();
        }
      } catch (error) {
        console.error('Error saving data:', error);
        useToast().error('An error occurred while saving data');
      } finally {
        this.isSubmitting = false;
      }
    },
    async DownloadFile() {
      if (this.isSubmitting) return;

      this.isSubmitting = true;
      try {
        this.updateApplicantAccountIds(this.formData.selectedShortName);
        const token = localStorage.getItem('access_token');
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`, // Include the token in the headers
          },
          responseType: 'blob'
        };
        const uploadData = new FormData();
        uploadData.append('applicantName', this.formData.applicantName);
        uploadData.append('accountName', this.formData.accountName);
        uploadData.append('location', this.formData.location);
        uploadData.append('vesselName', this.formData.vesselName);
        uploadData.append('voyageName', this.formData.voyageName);

        const response = await axios.post('/downLoad_import_list?applicantid=' + this.formData.applicantName + '&accountid=' + this.formData.accountName + '&locationid=' + this.formData.location + '&vessselid=' + this.formData.vesselName + '&voyageid=' + this.formData.voyageName, uploadData, config);
        //console.log(response)
        if (response.data[0] === 0) {
          useToast().error(response.data[1]);
        } else {
          const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
          saveAs(blob);
          //res(response.data);
          //useToast().success(response.data);
          //this.htmlContent = response.data;
          //this.resetNewContainer();
        }
      } catch (error) {
        console.error('Error downloading file:', error);
        useToast().error('An error occurred while downloading file');
      } finally {
        this.isSubmitting = false;
      }
    },
    handleChange(event) {
      //console.log(event.target.value)
      const selectedShortName = event.target.value;
      this.updateApplicantAccountIds(selectedShortName);
    },
    updateApplicantAccountIds(value) {
      const AppAcc = cs.GetAppAccFromParty(value)
      this.formData.applicantName = AppAcc.applicantid
      this.formData.accountName = AppAcc.accountid
    },
  },
};
</script>

<style scoped>
.table-container {
  /*max-height: 100%;*/
  overflow: auto;
  border: 1px solid #ddd;
  border-radius: 10px;
}

.transaction-table {
  width: 100%;
  height: 100%;
  border-collapse: collapse;
}

.transaction-table th,
.transaction-table td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.transaction-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.transaction-table th .filter-icon {
  cursor: pointer;
  margin-left: 5px;
}
.upload-content-tile{
  margin-left: 10px;
  /* subtle card background */
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  padding: 10px;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.08);
  border: 1px solid rgba(0,0,0,0.04);
}
.panel{
  background: transparent;
  border-radius: 10px;
  overflow: hidden;
}
.panel-header{
  background: linear-gradient(90deg, #f1f6ff, #ffffff);
  padding: 12px 18px;
  border-bottom: 1px solid rgba(0,0,0,0.04);
}
.panel-header h2{
  margin: 0;
  font-size: 18px;
  color: #1f3a93; /* darker blue for title */
}
.panel-body{
  padding: 16px 0 0 0; /* keep upload-content-tile's padding intact */
}
.upload-content-tile h1 {
  color: #343a40;
  font-size: 28px;
  margin-bottom: 25px;
}

.form-row {
  display: flex;
  align-items: center;
}

/* two inline columns inside a single form row */
.two-inline {
  display: flex;
  gap: 24px;
}
.two-inline .form-column {
  display: flex;
  align-items: center;
}
.two-inline .form-column .form-label {
  width: 140px; /* a bit narrower to fit two columns */
}

/* three inline columns layout */
.three-inline {
  display: flex;
  gap: 18px;
  align-items: center;
}
.three-inline .form-column {
  display: flex;
  align-items: center;
}
.three-inline .form-column .form-label {
  width: 120px;
}
.three-inline .form-column .custom-select,
.three-inline .form-column .custom-vselect {
  width: 220px !important;
}

.form-row label {
  font-weight: bold;
  margin-right: 10px;
  width: 200px;
  /* Adjust width as needed */
  color: #495057;
}

select,
v-select {
  width: 150px;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  background-color: #FFF;
}

/* larger fixed-width for the import VCN select */
.custom-vselect {
  width: 400px !important;
  max-width: 400px;
}

.custom-vselect .vs__dropdown-toggle {
  width: 100% !important;
}

/* make the Import VCN column and its v-select larger on desktop */
.import-vcn-column .form-label {
  width: 200px; /* a bit wider label so the control can expand */
}
.import-vcn-column .custom-vselect {
  width: 540px !important;
  max-width: 540px;
}
.import-vcn-column .custom-vselect .vs__dropdown-toggle {
  width: 100% !important;
}

.custom-file-input {
  width: 100%;
  max-width: 300px;
  /* Adjust the width to match the select box */
  padding: 8px;
  border: 2px solid #ced4da;
  border-radius: 8px;
  font-size: 16px;
  color: #495057;
  background-color: #fff;
}

/* Responsive: stack inline fields on small screens */
@media (max-width: 800px) {
  .form-row {
    margin-left: 0;
    padding: 0 12px;
  }
  .two-inline {
    flex-direction: column;
    gap: 12px;
  }
  .two-inline .form-column {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
  }
  .two-inline .form-column .form-label {
    width: 100%;
    margin-bottom: 6px;
  }
  .two-inline .form-column .custom-select,
  .two-inline .form-column .custom-vselect,
  .custom-vselect {
    width: 100% !important;
    max-width: none;
  }
  /* ensure the enlarged import vcn select also collapses to full width on small screens */
  .import-vcn-column .custom-vselect {
    width: 100% !important;
    max-width: none;
  }
  /* stack three-inline as well on small screens */
  .three-inline {
    flex-direction: column;
    gap: 12px;
  }
  .three-inline .form-column {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
  }
  .three-inline .form-column .form-label {
    width: 100%;
    margin-bottom: 6px;
  }
  .three-inline .form-column .custom-select,
  .three-inline .form-column .custom-vselect {
    width: 100% !important;
    max-width: none;
  }
}

.form-actions {
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  gap: 14px; /* space between buttons */
}

/* base btn styles */
.form-actions .btn {
  padding: 10px 14px;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.15s ease, transform 0.05s ease;
}
.form-actions .btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}

/* specific button colors */
.btn-upload {
  background-color: #28a745; /* green */
}
.btn-upload:hover:not(:disabled) {
  background-color: #218838;
}
.btn-save {
  background-color: #ff8c00; /* orange */
}
.btn-save:hover:not(:disabled) {
  background-color: #e07a00;
}
.btn-download {
  background-color: #6c757d; /* gray */
}
.btn-download:hover:not(:disabled) {
  background-color: #5a6268;
}

/* keep legacy excel-button adjustments if present */
.excel-button {
  /* legacy helper class retained */
  padding-left: 6px;
  padding-right: 6px;
}
</style>